import React from 'react';
import { Tooltip } from 'antd';
import { AppstoreOutlined, TableOutlined, UnorderedListOutlined } from '@ant-design/icons';

export type LogViewType = 'cards' | 'table' | 'timeline';

interface Props {
  value: LogViewType;
  onChange: (v: LogViewType) => void;
}

const OPTIONS: { value: LogViewType; icon: React.ReactNode; label: string; desc: string }[] = [
  { value: 'cards', icon: <AppstoreOutlined />, label: 'Cards', desc: 'Card rows' },
  { value: 'table', icon: <TableOutlined />, label: 'Table', desc: 'Data table' },
  { value: 'timeline', icon: <UnorderedListOutlined />, label: 'Timeline', desc: 'Timeline rows' },
];

const LogViewSwitcher: React.FC<Props> = ({ value, onChange }) => (
  <div style={{ display: 'inline-flex', background: '#f4f4f6', borderRadius: 10, padding: 3, gap: 2 }}>
    {OPTIONS.map((opt) => {
      const active = value === opt.value;
      return (
        <Tooltip key={opt.value} title={opt.desc} placement="bottom">
          <button
            onClick={() => onChange(opt.value)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '6px 14px',
              borderRadius: 8,
              border: 'none',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: active ? 600 : 400,
              background: active ? '#fff' : 'transparent',
              color: active ? '#1a1a2e' : '#888',
              boxShadow: active ? '0 1px 4px rgba(0,0,0,0.10)' : 'none',
              transition: 'all 0.15s',
            }}
          >
            {opt.icon}
            {opt.label}
          </button>
        </Tooltip>
      );
    })}
  </div>
);

export default LogViewSwitcher;
